<template>
  <mf-toolbar v-if="isMobile" :logo="toolbarLogo" :logo-click-action="goToHome">
    <mf-button icon="menu" color="branco" type="icon" size="sm" @click="() => $emit('update:isMenuOpen', !isMenuOpen)" />
  </mf-toolbar>
  <mf-toolbar v-else :logo="toolbarLogo" :show-extension="isSelectingQuickActionGroups" :logo-click-action="goToHome">
    <template v-slot:search>
      <global-search />
    </template>
    <multi-user-change-client v-if="$getIsMultiUser() || $getIsAdmin()" class="multi-user-change-client" />
    <modules-select v-if="$getIsAdmin()" ref="modules" v-shortkey="['ctrl', 'shift', 'm']" @shortkey.native="$refs.modules.dialog = true" />
    <v-btn class="mx-2 custom-btn" color="marca-0-l30" @click="toggleUserflow">
      Suporte
      <mf-icon icon="contact_support" fill size="18" color="branco" />
    </v-btn>
    <notifications />
    <report-export-tracking />
    <logged-user-menu class="logged-user-menu" />
    <template v-slot:extension>
      <mf-quick-actions-bar />
    </template>
  </mf-toolbar>
</template>

<script>
import MultiUserChangeClient from '@/components/MultiUserChangeClient.vue'
import LoggedUserMenu from '@/components/LoggedUserMenu.vue'
import ModulesSelect from '@/components/ModulesSelect.vue'
import Notifications from '@/components/notifications/Notifications.vue'
import ReportExportTracking from '@/components/report-export-tracking/ReportExportTracking.vue'
import GlobalSearch from './GlobalSearch.vue'
import userflow from 'userflow.js'
import { mapState } from 'vuex'

export default {
  components: {
    MultiUserChangeClient,
    LoggedUserMenu,
    ModulesSelect,
    Notifications,
    ReportExportTracking,
    GlobalSearch,
    MfQuickActionsBar: () => import('@/components/quick-actions/MFQuickActionsBar.vue'),
  },
  props: {
    isMenuOpen: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      isSelectingQuickActionGroups: (state) => state.isSelectingQuickActionGroups,
    }),

    toolbarLogo() {
      return this.$getWhitelabelLogo()
    },
  },
  methods: {
    goToHome() {
      if (this.$getFirstValue()) {
        this.$router.push('/primeiro-valor').catch(() => {})
      } else {
        this.$router.push('/home').catch(() => {})
      }
    },
    toggleUserflow() {
      userflow.toggleResourceCenter()
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .toolbar-custom-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.2s;

  &:hover {
    background: $marca-0-l10;
  }
}
.custom-btn {
  font-weight: 400;
  text-transform: unset;
  letter-spacing: 0.02px;
  border-radius: 16px;
  padding: 0px 12px 0px 16px;
  font-size: 14px;
  line-height: 18px;
  height: 38px !important;

  ::v-deep .v-btn__content {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }
}
</style>
